// @ts-nocheck
import { populate } from 'populate';
import type { Container } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../../common/buttons/ButtonExtraLargeLayout';

const raw = {
  width: 664,
  height: 667,
  x: 0,
  y: 0,
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      runtimeType: null,
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      parent: '',
      data: null,
      stateByName: {},
    },
    {
      id: '5b27738a-409c-40da-bd39-24b46a4ee445',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Tournament_Trophies_Illustration_Background',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {},
    },
    {
      id: '9f3ad1fd-3d57-4497-83d9-c4195305ee2f',
      type: 'Sprite',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 80,
      anchor: {
        x: 0.5,
        y: 0,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Tournament_Trophies_Illustration',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {},
    },
    {
      id: '7128fceb-f6d4-48f8-9425-6331f6f3e466',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 543,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'You have no tournament',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 2,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: undefined,
      stateByName: {},
    },
    {
      id: '2741982b-17c5-4428-967a-de7ebf965451',
      type: 'Container',
      runtimeType: null,
      name: 'createButton',
      className: '',
      x: 0,
      y: 671,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      hitArea: {
        type: 'None',
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        tapSound: 'UI_Button_Click'
      },
      stateByName: {},
    },
    {
      id: 'c06822ab-a67f-4ee5-88d5-79ccbd667d39',
      type: 'NineSlicePlane',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 229,
        y: 66,
      },
      width: 458,
      height: 132,
      leftWidth: 55,
      topHeight: 55,
      rightWidth: 55,
      bottomHeight: 55,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      texture: 'Button_Background',
      parent: '2741982b-17c5-4428-967a-de7ebf965451',
      data: undefined,
      stateByName: {},
    },
    {
      id: 'f81abbab-b4fc-4ac2-ab9e-64136bf81466',
      type: 'Layout',
      runtimeType: null,
      name: '',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1,
      },
      pivot: {
        x: 0,
        y: 0,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: true,
      parent: '2741982b-17c5-4428-967a-de7ebf965451',
      data: {
        color: 'green',
      },
      stateByName: {},
    },
    {
      id: 'af12d7d4-18d2-45f2-97ef-28b7764159ee',
      type: 'Text',
      runtimeType: null,
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5,
      },
      scale: {
        x: 1,
        y: 1,
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None',
      },
      text: 'CREATE TOURNAMENT',
      localize: true,
      maxWidth: 393,
      maxHeight: 85,
      maxFontSize: 0,
      style: {
        fontSize: 35,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#ebfee8',
        stroke: '#006f0d',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0,
      },
      parent: '2741982b-17c5-4428-967a-de7ebf965451',
      data: undefined,
      stateByName: {},
    },
  ],
  version: '1.0.0',
  stateNames: [],
  animations: [],
} as const;

export class TournamentCreatePanelLayout {
  static raw = raw;
  root: Container;
  createButton: Container;

  mInternalTypes: {
    Raw: typeof raw;
    StateName: never;
    ModelByName: {
      root: (typeof raw)['list'][0];
      createButton: (typeof raw)['list'][4];
    };
  };

  constructor() {
    populate(this, raw);
  }
}
